<div class="liked-shared-wrapper" [ngClass]="{'flex-direction-col':fdcol}" *ngIf="isApplets">
  <div class="liked-group btn" (click)="liked()">
    <img [src]="'/assets/imgs/common/like' + (isLiked?'d':'') + '.png'" />
  </div>
  <div class="shared-group btn"(click)="shared()">
    <img src="/assets/imgs/common/share.png" />
  </div>
</div>